// True when the app was launched from the home screen (installed PWA) rather than a browser tab
export function isStandalone() {
  const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
  try {
    if (standalone) {
      sessionStorage.setItem('aerocle-standalone', '1')
      return true
    }
    return sessionStorage.getItem('aerocle-standalone') === '1'
  } catch (e) {
    return standalone
  }
}

export const PWA_TABS = { companies: '/pwa/companies', contacts: '/pwa/contacts' }

// The last page shown on each tab ({ path, state }), so tapping the tab reopens it
export const lastTabPages = {}

export function tabOf(path) {
  return Object.keys(PWA_TABS).find(tab => path.startsWith(PWA_TABS[tab])) || null
}
